import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgPaperClip(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M18.2982 3.90612L6.5616 16.9614C5.42167 18.2294 5.10393 19.6375 5.30713 20.9952C5.51575 22.3891 6.28569 23.7743 7.39646 24.8505C8.50892 25.9284 9.87817 26.615 11.1959 26.7321C12.4661 26.845 13.768 26.4413 14.9031 25.1787L25.5884 13.2929C27.3559 11.3268 26.8888 9.18973 25.629 7.96969C24.9862 7.3472 24.1606 6.9909 23.3239 6.99744C22.5118 7.00379 21.5633 7.35267 20.6437 8.37559L10.5486 19.605C10.2403 19.9479 10.177 20.2584 10.1987 20.5066C10.2228 20.7819 10.3617 21.0695 10.5935 21.2939C10.826 21.5191 11.0938 21.6258 11.3199 21.6308C11.5132 21.6351 11.7838 21.57 12.0912 21.228L21.6558 10.5889L23.515 12.2602L13.9504 22.8994C13.1939 23.7409 12.2411 24.1518 11.2646 24.1302C10.3208 24.1093 9.47216 23.6882 8.85427 23.0898C7.6108 21.8856 7.09664 19.7053 8.68941 17.9336L18.7846 6.70421C20.12 5.21874 21.7133 4.50995 23.3044 4.49751C24.8708 4.48527 26.31 5.14907 27.3681 6.17377C29.5102 8.24811 30.19 11.9137 27.4476 14.9643L16.7622 26.8501C15.0948 28.7049 13.019 29.404 10.9746 29.2223C8.97762 29.0448 7.09514 28.0396 5.65682 26.646C4.21682 25.2507 3.13693 23.3848 2.83467 21.3653C2.527 19.3096 3.03734 17.1422 4.70244 15.29L16.4391 2.23474L18.2982 3.90612Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgPaperClip);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
